import { render, staticRenderFns } from "./batchOperation.vue?vue&type=template&id=39484357&scoped=true&"
import script from "./batchOperation.vue?vue&type=script&lang=ts&"
export * from "./batchOperation.vue?vue&type=script&lang=ts&"
import style0 from "./batchOperation.vue?vue&type=style&index=0&id=39484357&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39484357",
  null
  
)

export default component.exports